import { call, put } from "redux-saga/effects";
import { setLoadingAction } from "../redux/loading";
import {
  LOAD_INITIAL_QUESTION,
  CHECK_ANSWER,
  LOAD_QUESTION,
  LOAD_AI_DIAGNOSIS_QUESTION,
  LOAD_QUESTION_LIST,
  setAnsweringQuestionsAction
} from "../redux/answeringQuestions/answeringQuestions";

const createActionType = type => [ type, ...createSuccessAndFailure( type ) ];
const createSuccessAndFailure = type => [ `${ type }.SUCCESS`, `${ type }.FAILURE` ];

function * callRequest ( type, request, action ) {

  const [ SUCCESS, FAILURE ] = createSuccessAndFailure( type );

  try {
    const response = yield call( request, action.payload );
    yield put( {
      type : SUCCESS,
      payload : response
    } );
  } catch ( error ) {
    yield put( {
      type : FAILURE,
      payload : error
    } );
  }

}

const createRequest = ( type, request ) => {

  return function * ( action ) {
    yield call( callRequest, type, request, action );
  };

};

const createRequestForAnsweringQuestions = ( type, request ) => {

  return function * ( action ) {
    switch ( type ) {
      case CHECK_ANSWER :
      case LOAD_AI_DIAGNOSIS_QUESTION :
        yield put( setAnsweringQuestionsAction( { isNextQuestion : false } ) );
        break;
    }
    switch ( type ) {
      case LOAD_QUESTION :
        yield put( setAnsweringQuestionsAction( { isShowOXPopup : false } ) );
        break;
    }
    switch ( type ) {
      case LOAD_INITIAL_QUESTION :
      case LOAD_QUESTION :
      case LOAD_AI_DIAGNOSIS_QUESTION :
      case LOAD_QUESTION_LIST :
        yield put( setLoadingAction( { isShowBall : true } ) );
        break;
    }
    yield call( callRequest, type, request, action );
    switch ( type ) {
      case LOAD_INITIAL_QUESTION :
      case LOAD_QUESTION :
      case LOAD_AI_DIAGNOSIS_QUESTION :
      case LOAD_QUESTION_LIST :
        yield put( setLoadingAction( { isShowBall : false } ) );
        break;
    }
  };

};

export {
  createActionType,
  createRequest,
  createRequestForAnsweringQuestions
};
